import { api } from '@/lib/api/client';

export interface FollowUpTemplate {
  id: number;
  name: string;
  subject: string;
  bodyHtml: string;
  xkEventId: number | null;
  enabled: boolean;
  sendDelayHours: number;
  couponPoolId: number | null;
  branding: Record<string, unknown> | null;
}

export const followupApi = {
  list: (eventId?: number) =>
    api.get<FollowUpTemplate[]>('/followup-templates', {
      params: eventId ? { eventId } : {},
    }),
  get: (id: number) => api.get<FollowUpTemplate>(`/followup-templates/${id}`),
  create: (input: Partial<FollowUpTemplate>) =>
    api.post<FollowUpTemplate>('/followup-templates', input),
  update: (id: number, input: Partial<FollowUpTemplate>) =>
    api.put<FollowUpTemplate>(`/followup-templates/${id}`, input),
  remove: (id: number) => api.delete<{ ok: true }>(`/followup-templates/${id}`),
  stats: (eventId?: number) =>
    api.get<Record<string, number>>('/followup/stats', {
      params: eventId ? { eventId } : {},
    }),
};
